// extracted by mini-css-extract-plugin
export default {"Confirmation":"Confirmation_Confirmation__MtkLg"};